import React from 'react'
import {Link as RouterLink, Navigate, Outlet, useLocation} from 'react-router-dom'
import useRootHook from "../hooks/useRoot";
import { Box, CircularProgress } from '@mui/material';

const AclRouterLink = React.forwardRef((props, ref) => {
    const {userData} = useRootHook()

    const path = props.to.split('?')

    const newProps = {...props}
    delete newProps.forceRoles

    if (props.forceRoles && props.forceRoles.includes(userData.role)) {
        return <RouterLink ref={ref} {...newProps}/>
    }

    if (!props.forceRoles && userData.urls && userData.urls.includes(path[0])) {
        return <RouterLink ref={ref} {...newProps}/>
    }
    return <div style={{display: "none"}}>{props.children}</div>
})

const RequireAuth = (props) => {
    const { authed, userData } = useRootHook()
    const location = useLocation()

    const { children } = props
    const normalizePath = (p) => {
        if (!p) return '/'
        let out = String(p).split('?')[0]
        if (!out.startsWith('/')) out = `/${out}`
        if (out.length > 1 && out.endsWith('/')) out = out.slice(0, -1)
        return out
    }

    const pathName = normalizePath(location.pathname)

    // Пока userData не загружен (null), не редиректить — иначе срабатывает allowed = false и редирект на /
    if (authed && props.forceRoles && (userData == null || userData.role == null)) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                <CircularProgress />
            </Box>
        )
    }

    let allowed = false

    if (authed && props.forceRoles && props.forceRoles.includes(userData?.role)) {
        allowed = true
    } else if (authed && !props.forceRoles && Array.isArray(userData?.urls)) {
        const urls = userData.urls.map(normalizePath)
        // allow exact match OR sub-routes (e.g. /projects/edit) when /projects is allowed
        allowed = urls.some((u) => pathName === u || (u !== '/' && pathName.startsWith(`${u}/`)))
    }

    return allowed ? (
        children ? children : <Outlet />
    ) : (
        <Navigate to={authed ? '/' : '/login'} replace state={{ path: location.pathname }} />
    );
}

export {AclRouterLink, RequireAuth}